import { render, staticRenderFns } from "./closing-confirmed.vue?vue&type=template&id=2e1b808c"
import script from "./closing-confirmed.vue?vue&type=script&lang=js"
export * from "./closing-confirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports